import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import DotIcon from '@material-ui/icons/Lens';
import { TextField } from '@material-ui/core';

import securityDetailsStyles from './securityDetails.module.css';
import commonStyles from '../../../../common/common.module.css';
import Grid from '@material-ui/core/Grid';


const styles = (theme: Theme) =>

  createStyles({
    textField: {
      color: 'var(--primaryblue)'
    },
    input: {
      color: 'var(--primaryblue)',
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    grey: {
      color: 'rgb(0,0,0,0.26)',
      fontSize: '14px'
    },
    red: {
      color: 'red',
      fontSize: 18,
      marginLeft: '5px',
    },
    green: {
      color: 'green',
      fontSize: 18,
      marginTop: '7px',
      marginLeft: '5px',
    },
    textFieldWidth: {
      width: '100%'
    },
  });

interface SecurityDetailsProps {
  classes: any;
  iacNumber: string;
  iacNumberValid: boolean | null;
  showIacDot: boolean;
  loseFocus: () => void;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, type: string) => void;
  disabled: boolean;
};

const securityDetails = (props: SecurityDetailsProps) => {

  const { classes } = props;
  const iconStyle: string = props.iacNumberValid ? classes.green : classes.red;

  return (

    <div className={ securityDetailsStyles.inputsWrapper }>
      <Grid container direction="row" >
        <Grid item sm={10}  xs={11} className={ `${ commonStyles.inputLabelWrapper } ${ securityDetailsStyles.iacField }` } >
          <label className={ commonStyles.inputLabel }>IAC Number</label>
          <TextField
            id="carrier"
            variant="outlined"
            value={ props.iacNumber }
            onBlur={ props.loseFocus }
            onChange={ (e: any) => props.handleChange(e, 'text') }
            disabled={ !props.disabled }
            InputProps={{
              className: classes.textField,
              classes: { input: classes.input }
            }}
            InputLabelProps={{
              className: props.iacNumber ? classes.blue : classes.grey

            }}
            className={ [classes.textFieldWidth, securityDetailsStyles.inputMargin].join(" ") }
          />
        </Grid>
        <Grid item sm={2} xs={1} style={{ display: 'flex', alignItems: 'center' }} >
          { props.showIacDot  &&
            <DotIcon className={ iconStyle } />
          }
        </Grid>
      </Grid>
    </div>

  );
};

export default withStyles(styles)(securityDetails);